import React, { useState, useContext } from 'react';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { SurveyUnsubscriptionModal } from '../SurveyEmailPreferences/SurveyUnsubscriptionModal';
import {
  unsubscribeFromAllEmail,
  unsubscribeFromAllEmailSuccess
} from '../../analytics/email';
import { addAnalyticEvent } from '../../analytics/common';
import ErrorBoundary from '../../contexts/ErrorBoundary';
import { BannerContext, BannerProvider } from '../../contexts/BannerContext';
import { SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS } from '../../constants/bannerConstants';

export function Preferences() {
  const [unsubscribeToggle, setUnsubscribeToggle] = useState(false);
  const { openSuccessAlert } = useContext(BannerContext);
  const openUnsubscribeModal = () => {
    addAnalyticEvent(unsubscribeFromAllEmail);
    setUnsubscribeToggle(true);
  };

  const handleUnsubCancel = () => {
    setUnsubscribeToggle(false);
  };

  const handleUnsubSuccess = (emailRes) => {
    addAnalyticEvent(unsubscribeFromAllEmailSuccess);
    setUnsubscribeToggle(false);
    openSuccessAlert(SURVEY_EMAIL_UNSUBSCRIBE_SUCCESS, emailRes);
  };

  const handleUnsubError = () => {
  };

  return (
    <div className="component">
      <Row>
        <Col>
          <h2>
            <u style={{ textDecorationColor: '#F96302' }}>Survey Emails</u>
          </h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            If you don&apos;t want to provide customer feedback, you can unsubscribe from our survey emails.
          </p>
        </Col>
      </Row>
      <Row>
        <Col nopadding xs={6} sm={8} md={8} lg={8} />
        <Col xs={6} sm={4} md={4} lg={4}>
          <Button
            data-testid="unSubscribeModalButton"
            outline
            onClick={openUnsubscribeModal}
          >
            Opt Out of  Survey Emails
          </Button>
        </Col>
      </Row>

      {unsubscribeToggle && (
        <SurveyUnsubscriptionModal
          handleClose={handleUnsubCancel}
          handleSuccess={handleUnsubSuccess}
          handleError={handleUnsubError}
        />
      )}
    </div>
  );
}

export function SurveyEmailUnsubscribePreferences() {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences />
      </BannerProvider>
    </ErrorBoundary>
  );
}
